import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { ResponsePaginateSuccess, ResponseSuccess } from '@atmi/core/models';

import { RoleModuleConfiguration } from '@sim/role/models/configuration';
import { Capability, Role } from '@sim/role/models/role';
import { RoleConfigurationService } from '@sim/role/token';

@Injectable({
  providedIn: 'root',
})
export class RoleApiService {
  private readonly path = `${this.config.basePath}/roles`;

  constructor(
    @Inject(RoleConfigurationService) private readonly config: RoleModuleConfiguration,
    private readonly http: HttpClient,
  ) {
  }

  index() {
    //console.trace('RoleApiService: Fetching roles from', this.path);
    return this.http.get<ResponsePaginateSuccess<Role[]>>(this.path).pipe(
      map((res) => ({ data: res.data, count: res.count })),
      first(),
    );
  }

  indexCapabilities() {
    const path = `${this.config.basePath}/capabilities`;

    return this.http.get<ResponseSuccess<Capability[]>>(path).pipe(
      map((res) => res.data),
      first(),
    );
  }

  get(id: string) {
   // console.trace(`RoleApiService: Fetching role with id ${id} from`, `${this.path}/${id}`);
    return this.http.get<ResponseSuccess<Role>>(`${this.path}/${id}`).pipe(
      map((res) => res.data),
      first(),
    );
  }

  post(role: Role) {
    console.log('RoleApiService: Creating new role at', this.path, 'with data:', role);
    return this.http.post<ResponseSuccess<Role>>(this.path, role).pipe(
      map((res) => res.data),
      first(),
    );
  }

  postCapability(capability: string) {
    return of(capability);
  }

  put(role: Role) {
    console.log(`RoleApiService: Updating role with id ${role.id} at`, `${this.path}/${role.id}`, 'with data:', role);
    return this.http.put<ResponseSuccess<Role>>(`${this.path}/${role.id}`, role).pipe(
      map((res) => res.data),
      first(),
    );
  }

  remove(id: string) {
    console.log(`RoleApiService: Deleting role with id ${id} at`, `${this.path}/${id}`);
    return this.http.delete(`${this.path}/${id}`).pipe(
      first(),
    );
  }

  removeCapability() {
    return of();
  }
}
